import { render, staticRenderFns } from "./FormCPF.vue?vue&type=template&id=3d99c14c&scoped=true&"
import script from "./FormCPF.vue?vue&type=script&lang=js&"
export * from "./FormCPF.vue?vue&type=script&lang=js&"
import style0 from "./FormCPF.vue?vue&type=style&index=0&id=3d99c14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d99c14c",
  null
  
)

export default component.exports